import { DayPilot } from "daypilot-pro-angular";
import { ResourceDriver } from "./resourceDriver";
import { ResourceBase } from "./resourceBase";
import { GroupType } from "../../common/enums";

export interface IResourceGroup {
  expanded: boolean;
  children: ResourceDriver[];

}

export class ResourceGroup extends ResourceBase implements IResourceGroup {
  constructor(
    public id: string,
    public isGroup: boolean,
    public type: string,
    public moveDisabled: boolean,
    public html: string,
    public name: string,
    public expanded: boolean,
    public children: ResourceDriver[],
    public numberOfChildren
  ) {

    if (type === GroupType.Standby) {
      name = name + " (" + numberOfChildren + ")";
    }

    super(id, isGroup, type, moveDisabled, html, name);
  }

  public static castToResourceGroup(args: DayPilot.ResourceData): ResourceGroup {
    return args as ResourceGroup;
  }

}



